// extracted by mini-css-extract-plugin
module.exports = {"login-button":"login-button__2nxPM","with-border":"with-border__GTOBm","navigation-login-button":"navigation-login-button__2yJme"};